import { useTranslation } from 'react-i18next';
import PainPointCard from './PainPointCard';

export default function PainPointSection() {
  const { t } = useTranslation();

  return (
    <div className="relative w-full min-h-0 md:min-h-[660px] bg-white py-10 md:py-[60px]">
      <div className="max-w-[1200px] mx-auto px-4 md:px-5">
        <h2
          data-aos-delay="100"
          data-aos="fade-up"
          className="font-bold text-[#222] text-[26px] md:text-[34px] text-center pb-[16px] md:pb-[20px] leading-tight"
        >
          {t('home.painPoints.title')}
        </h2>
        <p data-aos="fade-up" className="text-center text-[#666] text-[15px] md:text-[18px] leading-relaxed px-2">
          {t('home.painPoints.subtitle')}
        </p>
        <div className="pt-8 md:pt-[60px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-[20px]">
          {(t('home.painPoints.items', { returnObjects: true }) as Array<{ title: string; description: string }>).map((item, index) => (
            <PainPointCard
              key={index}
              index={index}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
